module.exports = __webpack_public_path__ + "static/media/icon-savings-dark.d2e50cc4.svg";